<template>
  <vs-popup class="add-price-tiers-item-to-cart-pop-up"
            id="popup"
            :title="`PRICE GUIDE (${price_details.formulation_code})`"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickAddItemToCart)" autocomplete="off">

          <h5 class="mb-4 mt-2">Price tiers</h5>
          <vs-table stripe :data="price_details.price">

            <template slot="thead">
              <vs-th>MinOQ</vs-th>
              <vs-th>MaxOQ</vs-th>
              <vs-th>Price (Excl vat {{ __accountCurrency() }})</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                <vs-td :data="data[indextr].from">
                  {{ data[indextr].from }}
                </vs-td>

                <vs-td :data="data[indextr].to">
                  {{ data[indextr].to }}
                </vs-td>

                <vs-td :data="data[indextr].price">
                  {{ data[indextr].price }}
                </vs-td>
              </vs-tr>
            </template>

          </vs-table>

          <div class="vx-row mb-8 mt-8">
            <div class="vx-col md:w-1/3 w-full md:mb-0">
              <ValidationProvider vid="quantity" name="quantity" :rules="'required|moq:'+min_order_quantity+'|maxoq:'+max_order_quantity" v-slot="{ errors }">
                <small class="label">Quantity needed</small>
                <vs-input  size="large" v-on:input="onTypeQuantity" v-model="createForm.quantity"  name="quantity" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/3 w-full md:mb-0">
              <ValidationProvider vid="price" name="price" rules="required" v-slot="{ errors }">
                <small class="label">Price per KG (Excl vat)</small>
                <vx-input-group class="">
                  <template slot="prepend">
                    <div class="prepend-text bg-warning">
                      <span>{{ __accountCurrency() }}</span>
                    </div>
                  </template>
                  <vs-input size="large" readonly v-model="createForm.price"   name="price" class=" required" label=""/>
                </vx-input-group>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/3 w-full md:mb-0">
              <ValidationProvider vid="price" name="price" rules="required" v-slot="{ errors }">
                <small class="label">Total price (Excl vat)</small>
                <vx-input-group class="">
                  <template slot="prepend">
                    <div class="prepend-text bg-warning">
                      <span>{{ __accountCurrency() }}</span>
                    </div>
                  </template>
                  <vs-input size="large" readonly v-model="createForm.total"   name="price" class=" required" label=""/>
                </vx-input-group>
              </ValidationProvider>
            </div>
          </div>

          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
            <vs-button @click="createForm = {}" class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'


  function initialState() {
    return {
      open: false,
      index: null,
      createForm: {},
      price_details: {},
    }
  }

export default {
  name: 'CalculateProductPricePopUp',
  data () {
    return initialState()
  },
  methods:{
    async openPopup (price_details, index) {
      try {
        Object.assign(this.$data, initialState())
        this.$refs.form.reset();
        this.index = index
        console.log({price_details});
        Object.assign(this.price_details, price_details)
        if(!!this.price_details.contract_price && this.price_details.contract_price.constructor === Array ) {
          this.price_details.price = this.price_details.contract_price
        }
        this.open = true;
      } catch (error) {

      }
    },
    async onClickAddItemToCart () {
      this.price_details.unit_price = this.createForm.price
      this.price_details.quantity = this.createForm.quantity
      this.open = false
      await this.$parent.onChangeQty(this.price_details, this.index)
    },
    onTypeQuantity() {
      const quantity = Number(this.createForm.quantity)
      let price;
      this.price_details.price.forEach((item) => {
        const max = Number(item.to)
        const min = Number(item.from)
        if(max >= quantity && quantity >= min) {
          this.createForm.price = (Number(item.price)).toFixed(2)
          price =  Number(item.price) * quantity
        }
      })
      this.createForm.total = Number(price).toFixed(2)
    },
  },
  computed: {
    min_order_quantity: function () {
      return Number(this.price_details.price[0].from)
    },
    max_order_quantity: function () {
      const price_tiers_max = Number(this.price_details.price[this.price_details.price.length -1].to)
      const min_order_qty = Number(this.price_details.min_order_quantity)
      return Number(this.price_details.price[this.price_details.price.length -1].to)
    }
  }
  ,
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
  .add-price-tiers-item-to-cart-pop-up >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 35% !important;
  }
</style>
